const baseApiUrl = process.env.REACT_APP_API_URL;

export const reviewUrls = {
	quotaSubmittionStatusData: baseApiUrl + "Quota/GetQuotaStatusGrpahData?",
	consumptionByCountry: baseApiUrl + "Home/GetScenarioConsumptionByCountry?",
	geoData: baseApiUrl + "Home/GetGeoChart",
	synchronizationStatus: baseApiUrl + "Home/GetSynchronizationStatus?",
	orderStatus: baseApiUrl + "Review/GetOrderStatus?",
	userCountries: baseApiUrl + "GetUserCountries?",
	scenarios: baseApiUrl + "Review/GetScenarios?",
	approvalStats: baseApiUrl + "Home/GetApprovalStatistics?",
	getQuotaDetailsForScenario: baseApiUrl + "Review/GetQuotaDetailsForScenario?",
	getWeekStatus: baseApiUrl + "Review/GetWeekStatus?",
	postOrderDecision: baseApiUrl + "Review/PostOrderDecision?",
	getModifiedOrders: baseApiUrl + "Review/GetModifiedOrdersforCountry?",
	exportFile: baseApiUrl + "Review/ExportFile?",
	deleteModifiedOrders: baseApiUrl + "Review/DeleteModifiedOrders",
	getOrders : baseApiUrl + "OrderModification/GetOrders?",
	submitOrderModifications : baseApiUrl + "Review/SubmitOrderModificationStickToQuota",
	submitModification: baseApiUrl + "Review/SubmitModification?",
	exportExcel: baseApiUrl + "Review/ExportExcel",
	importExcel: baseApiUrl + "Review/ImportExcel",
	getBlockedCustomersConsumption: baseApiUrl + "Review/GetBlockedCustomersConsumption",
	Downloadfile : baseApiUrl + "Define/DownloadFile?",
	Upload : baseApiUrl + "Approve/Upload",
	GetCurrentWeek : baseApiUrl +"OrderModification/GetCurrentWeek",
	RecallModification : baseApiUrl + "Review/RecallModifications?",
	StickToQuota : baseApiUrl + "Review/StickToQuota",
	EditOrders : baseApiUrl + "Review/EditOrders",
	UnblockFullOrderMSQ : baseApiUrl + "Review/UnblockFullOrderMSQ",
	DoNothing : baseApiUrl + "Review/DoNotModify",
	SubmitOrderDecision : baseApiUrl + "Review/PostOrderDecision",
	UpsertPreference : baseApiUrl + "Review/UpsertPreference",
	GetModificationPreference : baseApiUrl + "Review/GetModificationPreferences",
	exportReviewOrderQuota: baseApiUrl + "Review/ExportReviewOrderQuota?",
	exportReviewOrderQuotaAndConsumption : baseApiUrl + "Review/ExportReviewOrderQuotaAndConsumption?"
};